export default {
  title: 'Jufair',
  home: 'Home',
  logout: 'Logout',
  login: 'Login'
}
